import { defineKey as T } from '@ha/intl';

import BerlinImg from 'img-src/top-cities/berlin.jpg';
import RotterdamImg from 'img-src/top-cities/rotterdam.jpg';
import BarcelonaImg from 'img-src/top-cities/barcelona.jpg';
import MilanImg from 'img-src/top-cities/milan.jpg';
import ViennaImg from 'img-src/top-cities/vienna.jpg';
import MadridImg from 'img-src/top-cities/madrid.jpg';
import BrusselsImg from 'img-src/top-cities/brussels.jpg';
import ParisImg from 'img-src/top-cities/paris.jpg';
import LondonImg from 'img-src/top-cities/london.jpg';

export const ErrorMessages = {
  SEARCH_NOT_FOUND: T('We could not find the city searched'),
  SERVER_ERROR: T(
    'There was a problem processing your request. Please contact our support if the error persists.',
  ),
};

export const Titles = {
  en: 'HousingAnywhere: Mid to Long-Term Rentals in 400+ cities',
  fr: 'HousingAnywhere: Location moyenne et longue durée dans 400 villes',
  de: 'HousingAnywhere: Mittel- & Langfristige Unterkünfte | 400+ Städte',
  es: 'HousingAnywhere: Alquiler a medio y largo plazo en 400 ciudades',
  it: 'HousingAnywhere: Affitti a medio e lungo termine | 400 città',
  nl: 'HousingAnywhere: Mid- tot langetermijn huurwoningen | 400+ steden',
  pt: 'HousingAnywhere: Aluguel de médio e longo prazo em 400 cidades',
};

export const DefaultSuggestionsItemsCount = 8;

export const TopCities = [
  {
    imageUrl: BerlinImg,
    name: T('Berlin'),
    description: T('home_page_top_cities_berlin_description'),
    urls: {
      en: '/s/Berlin--Germany',
      fr: '/fr/s/Berlin--Allemagne',
      de: '/de/s/Berlin--Deutschland',
      es: '/es/s/Berlín--Alemania',
      it: '/it/s/Berlino--Germania',
      nl: '/nl/s/Berlijn--Duitsland',
      pt: '/pt/s/Berlim--Alemanha',
      zh: '/zh/s/柏林--德国',
    },
  },
  {
    imageUrl: RotterdamImg,
    name: T('Rotterdam'),
    description: T('home_page_top_cities_rotterdam_description'),
    urls: {
      en: '/s/Rotterdam--Netherlands',
      fr: '/fr/s/Rotterdam--Pays~Bas',
      de: '/de/s/Rotterdam--Niederlande',
      es: '/es/s/Róterdam--Holanda',
      it: '/it/s/Rotterdam--Olanda',
      nl: '/nl/s/Rotterdam--Nederland',
      pt: '/pt/s/Roterdão--Países-Baixos',
      zh: '/zh/s/鹿特丹--荷兰',
    },
  },
  {
    imageUrl: ViennaImg,
    name: T('Vienna'),
    description: T('home_page_top_cities_vienna_description'),
    urls: {
      en: '/s/Vienna--Austria',
      fr: '/fr/s/Vienne--Autriche',
      de: '/de/s/Wien--Österreich',
      es: '/es/s/Viena--Austria',
      it: '/it/s/Vienna--Austria',
      nl: '/nl/s/Wenen--Oostenrijk',
      pt: '/pt/s/Viena--Áustria',
      zh: '/zh/s/Vienna--奥地利',
    },
  },
  {
    imageUrl: BrusselsImg,
    name: T('Brussels'),
    description: T('home_page_top_cities_brussels_description'),
    urls: {
      en: '/s/Brussels--Belgium',
      fr: '/fr/s/Bruxelles--Belgique',
      de: '/de/s/Brüssel--Belgien',
      es: '/es/s/Bruselas--Bélgica',
      it: '/it/s/Bruxelles--Belgio',
      nl: '/nl/s/Brussel--België',
      pt: '/pt/s/Bruxelas--Bélgica',
      zh: '/zh/s/Brussels--比利时',
    },
  },
  {
    imageUrl: BarcelonaImg,
    name: T('Barcelona'),
    description: T('home_page_top_cities_barcelona_description'),
    urls: {
      en: '/s/Barcelona--Spain',
      fr: '/fr/s/Barcelone--Espagne',
      de: '/de/s/Barcelona--Spanien',
      es: '/es/s/Barcelona--España',
      it: '/it/s/Barcellona--Spagna',
      nl: '/nl/s/Barcelona--Spanje',
      pt: '/pt/s/Barcelona--Espanha',
      zh: '/zh/s/巴塞罗那--西班牙',
    },
  },
  {
    imageUrl: MilanImg,
    name: T('Milan'),
    description: T('home_page_top_cities_milan_description'),
    urls: {
      en: '/s/Milan--Italy',
      fr: '/fr/s/Milan--Italie',
      de: '/de/s/Mailand--Italien',
      es: '/es/s/Milán--Italia',
      it: '/it/s/Milano--Italia',
      nl: '/nl/s/Milaan--Italië',
      pt: '/pt/s/Milão--Itália',
      zh: '/zh/s/Milan--意大利',
    },
  },
  {
    imageUrl: MadridImg,
    name: T('Madrid'),
    description: T('home_page_top_cities_madrid_description'),
    urls: {
      en: '/s/Madrid--Spain',
      fr: '/fr/s/Madrid--Espagne',
      de: '/de/s/Madrid--Spanien',
      es: '/es/s/Madrid--España',
      it: '/it/s/Madrid--Spagna',
      nl: '/nl/s/Madrid--Spanje',
      pt: '/pt/s/Madrid--Espanha',
      zh: '/zh/s/马德里--西班牙',
    },
  },
  {
    imageUrl: LondonImg,
    name: T('London'),
    description: T('home_page_top_cities_london_description'),
    urls: {
      en: '/s/London--United-Kingdom',
      fr: '/fr/s/Londres--Royaume~Uni',
      de: '/de/s/London--Vereinigtes-Königreich',
      es: '/es/s/Londres--Reino-Unido',
      it: '/it/s/Londra--Regno-Unito',
      nl: '/nl/s/Londen--Verenigd-Koninkrijk',
      pt: '/pt/s/Londres--Reino-Unido',
      zh: '/zh/s/伦敦--英国',
    },
  },
  {
    imageUrl: ParisImg,
    name: T('Paris'),
    description: T('home_page_top_cities_paris_description'),
    urls: {
      en: '/s/Paris--France',
      fr: '/fr/s/Paris--France',
      de: '/de/s/Paris--Frankreich',
      es: '/es/s/París--Francia',
      it: '/it/s/Parigi--Francia',
      nl: '/nl/s/Parijs--Frankrijk',
      pt: '/pt/s/Paris--França',
      zh: '/zh/s/巴黎--法国',
    },
  },
];

export const tenantTestimonial = {
  title: T('home_testimonial_tenant_title'),
  text: T('home_testimonial_tenant_text'),
  ctaText: T('home_testimonial_tenant_cta_text'),
};

export const landlordTestimonial = {
  title: T('home_testimonial_landlord_title'),
  text: T('home_testimonial_landlord_text'),
  ctaText: T('home_testimonial_landlord_cta_text'),
};

export { STATE_NAME } from './stateName';
export { TopCitiesNameList } from './topCitiesNameList';
